module.exports = new __parcel__URL__("tine-flowers.2f097d1e.png").toString();